import React, { useState, useEffect, useContext } from 'react';
import { Panel, Statistic, Loadding } from '../../components';
import { Bar, Line } from '@ant-design/charts';
import { Row, Col, Avatar, Typography, Button, Space } from 'antd';
import {
  SoundTwoTone,
  CalendarOutlined,
  SettingOutlined,
  CheckOutlined,
} from '@ant-design/icons';

import './style';
import { MasterContext } from '../../App';
import { getOrderPending, getOrderCompleted } from '../../services/Stat';

export default React.forwardRef((props, ref) => {
  const { currentUser, authorities, currency_rate } = useContext(MasterContext);
  const { Title, Text } = Typography;
  const [orderPending, setOrderPending] = useState(undefined);
  const [orderCompleted, setOrderCompleted] = useState(undefined);
  const [rate, setRate] = useState(undefined);
  const [rateDatetime, setRateDatetime] = useState(undefined);
  useEffect(() => {
    asyncFetch();
    getOrderPending().then(data => setOrderPending(data));
    getOrderCompleted().then(data => setOrderCompleted(data));
  }, [])

  useEffect(() => {
    const find = currency_rate.find(x => x.name === '美元');
    if (find && find.rate5) {
      setRate((find.rate5 / 100).toFixed(4));
      setRateDatetime(find.pub_date);
    }
  }, [currency_rate])

  const data = [
    {
      type: '家具家电',
      sales: 91,
    },
    {
      type: '粮油副食',
      sales: 102,
    },
    {
      type: '生鲜水果',
      sales: 120,
    },
    {
      type: '美容洗护',
      sales: 145,
    },
    {
      type: '母婴用品',
      sales: 192,
    },
  ];
  const config = {
    data,
    xField: 'sales',
    yField: 'type',
    label: {
      position: 'left',
      style: {
        fill: '#0D0E68',
        opacity: 0.6,
      },
    },
    meta: {
      type: { alias: '类别' },
      sales: { alias: '销售额' },
    },
  };
  const [lineData, setLineData] = useState([]);
  const asyncFetch = () => {
    // fetch('https://gw.alipayobjects.com/os/bmw-prod/55424a73-7cb8-4f79-b60d-3ab627ac5698.json')
    //   .then((response) => response.json())
    //   .then((json) => setLineData(json))
    //   .catch((error) => {
    //     console.log('fetch data failed', error);
    //   });
  };
  const lineDataTemp = lineData.slice(550, lineData.length - 1);
  //const lineData2 = lineData.slice(0, lineData.length-1);
  let lineData2 = JSON.parse(JSON.stringify(lineDataTemp));
  let lineData3 = JSON.parse(JSON.stringify(lineDataTemp));
  lineData3.map(x => x.value = x.value * (Math.random() * 10));
  const lineconfig = {
    data: lineData2,
    xField: 'year',
    yField: 'value',
    seriesField: 'category',
    yAxis: { label: { formatter: (v) => `${v}`.replace(/\d{1,3}(?=(\d{3})+$)/g, (s) => `${s},`) } },
    legend: { position: 'right-top' },
    color: ['#1979C9', '#D62A0D', '#FAA219'],
  };
  const lineconfig2 = {
    data: lineData3,
    xField: 'year',
    yField: 'value',
    seriesField: 'category',
    yAxis: { label: { formatter: (v) => `${v}`.replace(/\d{1,3}(?=(\d{3})+$)/g, (s) => `${s},`) } },
    legend: { position: 'right-top' },
    color: ['#1979C9', '#D62A0D', '#FAA219'],
  };

  const renderOrderPending = () => {
    if (!orderPending) {
      return <Loadding />
    }

    return <table>
      {orderPending.map(x => {
        return <tr style={{ padding: '1rem 1rem' }}>
          <td style={{ padding: '0.5rem' }}>
            <Avatar style={{ backgroundColor: '#f56a00' }}>
              {x.date_left}天
            </Avatar>
          </td>
          <td>
            <div style={{ paddingLeft: '1rem' }}>
              <div><strong>#{x.po_code}</strong></div>
              <div style={{ color: '#9932CD', fontSize: '1rem' }}><span>pending</span> <span style={{ color: '#b0b0b0' }}>{x.delivery_deadline_date}</span></div>
            </div>
          </td>
          <td>
            <div style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', paddingLeft: '1rem' }}>
              {x.buyer_name}
            </div>
          </td>
          <td>
            <div style={{ paddingLeft: '1rem' }}>
              {x.date}
            </div>
          </td>
          <td>
            <div style={{ paddingLeft: '1rem' }}>
              {x.owner_name}
            </div>
          </td>
        </tr>
      })}
    </table>
  }

  const parseDate = (date) => {
    const temp = (date || '').replace('{', '').replace('}', '');
    const dates = temp.split(',').filter(x => x.length > 0);
    if (dates.length > 1) {
      return dates[0] + '...(' + dates.length - 1 + ')';
    } else {
      return dates[0];
    }
  }
  const renderOrderCompleted = () => {
    if (!orderCompleted) {
      return <Loadding />
    }

    return <table>
      {orderCompleted.map(x => {
        return <tr style={{ padding: '1rem 1rem' }}>
          <td style={{ padding: '0.5rem' }}>
            <Avatar style={{ backgroundColor: '#87d068' }}>
              <CheckOutlined />
            </Avatar>
          </td>
          <td>
            <div style={{ paddingLeft: '1rem' }}>
              <div><strong>#{x.po_code}</strong></div>
              <div style={{ color: '#87d068', fontSize: '1rem' }}><span>completed</span> <span style={{ color: '#b0b0b0' }}>2020-12-12</span></div>
            </div>
          </td>
          <td>
            <div style={{ paddingLeft: '1rem' }}>
              {parseDate(x.plan_delivery_date)}
            </div>
          </td>
        </tr>
      })}
    </table>
  }
  return (
    <div style={{ padding: '1rem 1.5rem' }}  >
      <Row gutter={16}>
        <Col span={8}>
          <Title level={4} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline' }}>欢迎,{currentUser.name}<div style={{ fontSize: '1.25rem', color: 'rgb(0,0,0,0.85)' }}><SoundTwoTone /> <strong>1美元={rate ? rate : '---'}人民币</strong> <sub>[<a href="https://www.boc.cn/sourcedb/whpj/index_1.html" target="_blank">{rateDatetime} 中国银行</a>]</sub></div></Title>
          <Space direction="vertical">
            <Text><span>[待办任务]</span><Button type="link" size="small">20TC03-021 / 20TC03-022 / 20TC03-023</Button></Text>
            <Text><span>[待办任务]</span><Button type="link" size="small">20TC04-021 / 20TC04-022 / 20TC04-023</Button></Text>
            <Text><span>[待办任务]</span><Button type="link" size="small">20TC05-021 / 20TC05-022</Button></Text>
          </Space>
          <Row >
            <Col span={8}>
              <Statistic style={{ margin: '0.5rem 0.5rem 0 0', padding: '1rem', backgroundColor: 'white' }} title="今日订单" value={2} />
            </Col>
            <Col span={8}>
              <Statistic style={{ margin: '0.5rem 0.5rem 0 0', padding: '1rem', backgroundColor: 'white' }} title="本月订单" value={9} />
            </Col>
            <Col span={8}>
              <Statistic style={{ margin: '0.5rem 0rem 0 0', padding: '1rem', backgroundColor: 'white' }} title="年度订单" value={99} />
            </Col>
          </Row>
        </Col>
        <Col span={10}>
          <Panel
            title={<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}><span>近期待发订单 (15)</span><Button size="small" type="text" icon={<CalendarOutlined />} /> </div>}
            body={renderOrderPending()}
          />
        </Col>
        <Col span={6}>
          <Panel title="近期已发订单 (8)"
            body={renderOrderCompleted()}
          />
        </Col>
      </Row>
      <Row gutter={16}>
        <Col span={8}>
          <div style={{ margin: '1rem 0 0 0' }}>
            <Panel title={<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}><span>客户销售额 Top5</span><Button size="small" type="text" icon={<SettingOutlined />} /> </div>} body={<div style={{ backgroundColor: '#fff', padding: '1rem', marginTop: '0.5rem', height: '11.5rem' }}>
              <Bar {...config} />
            </div>} />
          </div>
        </Col>
        <Col span={16}>
          <div style={{ margin: '1rem 0 0 0' }}>
            <Panel title={<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}><span>客户销售额Top 5走势图</span><Button size="small" type="text" icon={<SettingOutlined />} /> </div>} body={<div style={{ backgroundColor: '#fff', padding: '1rem', marginTop: '0.5rem', height: '11.5rem' }}>
              <Line {...lineconfig} />
            </div>} />
          </div>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col span={8}>
          <div style={{ margin: '1rem 0 0 0' }}>
            <Panel title={<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}><span>产品销售额 Top5</span><Button size="small" type="text" icon={<SettingOutlined />} /> </div>} body={<div style={{ backgroundColor: '#fff', padding: '1rem', marginTop: '0.5rem', height: '11.5rem' }}>
              <Bar {...config} />
            </div>} />
          </div>
        </Col>
        <Col span={16}>
          <div style={{ margin: '1rem 0 0 0' }}>
            <Panel title={<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}><span>产品销售Top 5走势图</span><Button size="small" type="text" icon={<SettingOutlined />} /> </div>} body={<div style={{ backgroundColor: '#fff', padding: '1rem', marginTop: '0.5rem', height: '11.5rem' }}>
              <Line {...lineconfig2} />
            </div>} />
          </div>
        </Col>
      </Row>
    </div>

  );
});
